/* Section: footer — back-to-top visibility + click, newsletter fake submit. */
(() => {
  const footer = document.querySelector('[data-section="footer"]');
  if (!footer) return;

  // ————— Back to top —————
  const toTop = footer.querySelector('.footer__to-top');
  if (toTop) {
    const threshold = 400;
    const update = () => {
      const show = window.scrollY > threshold;
      toTop.classList.toggle('footer__to-top--visible', show);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });

    toTop.addEventListener('click', () => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  // ————— Newsletter (front-end only for now) —————
  const form = footer.querySelector('.footer__form');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const status = form.nextElementSibling;
      if (input && input.value) {
        input.value = '';
        if (status?.classList.contains('footer__form-status')) {
          status.textContent = "You're in. Watch your inbox for your 10% code.";
        }
      }
    });
  }
})();
